import { CheckIcon, XIcon } from './icons';
import {
  passwordChecks,
  passwordStrength,
  type PasswordContext,
} from '../lib/passwordPolicy';

interface PasswordStrengthProps {
  password: string;
  context?: PasswordContext;
  id?: string;
}

/**
 * Checklist en vivo. La misma política vive en `server/src/lib/passwordPolicy.ts`
 * para que el cliente no sea la única barrera.
 */
export function PasswordStrength({ password, context, id }: PasswordStrengthProps) {
  if (!password) return null;

  const checks = passwordChecks(password, context);
  const strength = passwordStrength(checks);
  const progress = Math.round((strength.score / checks.length) * 100);

  return (
    <div className="password-strength" id={id} aria-live="polite">
      <div className="password-strength__head">
        <span>Seguridad de la contraseña</span>
        <strong className={`password-strength__label password-strength__label--${strength.tone}`}>
          {strength.label}
        </strong>
      </div>
      <div
        className={`password-strength__bar password-strength__bar--${strength.tone}`}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
        aria-label="Nivel de seguridad de la contraseña"
      >
        <span style={{ width: `${progress}%` }} />
      </div>
      <ul className="password-rules">
        {checks.map((check) => (
          <li key={check.id} className={check.met ? 'is-met' : undefined}>
            {check.met ? <CheckIcon size={13} /> : <XIcon size={13} />}
            <span>{check.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
